import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const AdminRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!["ADMIN", "SUPER_ADMIN"].includes(user.role)) return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
